export default __webpack_public_path__ + "static/mockup-iphone-store-dffe340da19787dcee24aff236eade57.png";